module.exports = __webpack_public_path__ + "img/wuliu.129014e0.png";